export default {"src":"/_next/static/media/g2-logo.5bad125f.svg","height":58,"width":57,"blurWidth":0,"blurHeight":0};